module.exports = __webpack_public_path__ + "img/GRI_Logo_NavBar.2b89e531.svg";